<!-- ATTN: this is a controller-only component, no template. Adds features to the map. -->
<nav class="bottom right vertical">
    <section class="bar vertical">
        <button type="button" aria-label="Reset map zoom" (click)="resetZoom.emit()">
            <img [src]="icons.home" alt="" />
        </button>
        <button type="button" aria-label="Zoom in" [disabled]="map.getZoom() >= map.getMaxZoom()" (click)="zoomIn()">+</button>
        <button type="button" aria-label="Zoom out" [disabled]="map.getZoom() <= map.getMinZoom()" (click)="zoomOut()">
            −
        </button>
    </section>
</nav>

<nav class="bottom left horizontal" *ngIf="isEditable">
    <section class="bar horizontal">
        <button type="button" aria-label="Edit location map" (click)="requestToggleEditing()" *ngIf="!isEditing">
            <img [src]="icons.edit" alt="" />
        </button>
        <ng-container *ngIf="isEditing">
            <input style="display: none" type="file" (change)="addImg($event.target)" #fileUpload />
            <button type="button" class="wide" (click)="cancelChanges()">CANCEL</button>
            <!-- <button (click)="fileUpload.click()" (keydown.enter)="fileUpload.click()">
                <img [src]="icons.image" />
            </button> -->
            <!-- <button (click)="requestSelectFeature()" (keydown.enter)="requestSelectFeature()">
                <img [src]="icons.add" />
            </button> -->
            <button type="button" class="wide" (click)="saveChanges()">SAVE</button>
        </ng-container>
    </section>
</nav>
